import React, { Component } from 'react';
import axios from 'axios';
import Helping from '../../helpers/Helping';
import Notification from '../layout/Notification';
import { MESSAGE } from '../../config/index';
import { API_URL } from '../../config/urls';
import route from '../../config/routes';
import { validateField } from "../../helpers/validationHelpers";
import LoadingButton from '../fields/LoadingButton';

const { UPDATE } = MESSAGE;
class List extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: {},
            url: API_URL.ADMIN_API + route.GET_NFT_COPIES,
            count: '',
            routeName: '',
            error_message: '',
            error_type: '',
            total: 0,
            activePage: 1,
            limit: 10,
            search: '',
            sorting: 'item_order',
            sort_type: 'ASC',
            sort_class: 'fa fa-sort-up',
            is_order: false,
            loadingBtns: {}
        };

        this.onSave = this.onSave.bind(this);
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    handleChange = async (e, code) => {
        console.log(e.target.value);
        const { value } = e.target;

        const items = this.state.items;
        items[code] = value;

        this.setState({ items });
        this.setState({ ...await validateField("numeric", code, value, "", 1) });
    }

    onSave(e, code, id) {
        e.preventDefault();

        let self = this;
        let items = this.state.items;
        let loadingBtns = this.state.loadingBtns;
        loadingBtns[id] = true

        this.setState({
            loadingBtns,
            error_message: "",
            error_type: ""
        })

        loadingBtns[id] = false;
        const data = {
            "item_order": items[code]
        };

        axios
            .put(self.state.url + "/" + id, data, Helping.getConfig())
            .then(response => {
                this.props.update(response.data.payload);
                self.setState({
                    error_message: Helping.getMessageString(UPDATE, "NFT copy's order"),
                    error_type: "success",
                    loadingBtns
                });
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);

                    return self.setState({
                        error_message: error.response.data.message,
                        error_type: "danger",
                        loadingBtns
                    });
                }
                return this.setState({
                    loadingBtns,
                    ...Helping.setNetworkRequestError(error, "nft copy's order")
                })
            });
    }

    sortBy(key) {
        let $this = this;
        let sortType = this.state.sort_type;
        let sortClass = this.state.sort_class;

        if (this.state.sort_type === 'ASC') {
            sortType = 'DESC';
            sortClass = 'fa fa-sort-down';
        }

        if (this.state.sort_type === 'DESC') {
            sortType = 'ASC';
            sortClass = 'fa fa-sort-up';
        }

        this.setState({
            sorting: key,
            activePage: 1,
            is_order: true,
            sort_type: sortType,
            sort_class: sortClass
        },
            () => $this.getItems());
    }

    render() {
        const { items } = this.state;
        return (
            <div class="actionModal modal fade reorderCopiesTbl" id="reorderCopiesModal" tabindex="-1" role="dialog" aria-labelledby="reorderCopiesModal" aria-hidden="true" >
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="">Reorder NFT Copies</h5>
                            <div class="select-header">
                                <form class="cardheader-search">
                                    <div class="cardsearch mr-0">
                                        <span class="search-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999"><path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)"></path></svg>
                                        </span>
                                        <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search" />
                                    </div>
                                </form>
                            </div>
                        </div>

                        {this.state.error_message &&
                            <Notification
                                type={this.state.error_type}
                                message={this.state.error_message}
                                callback={this.removeNetworkError}
                            />
                        }

                        <div class="modal-body">
                            <ul class="reorderCopies">
                                <li><h5 class="caption">Update Order: </h5></li>

                                {this.props.total > 0 && this.props.copies.map((copy, i) => (
                                    <li key={copy.id}>
                                        <div class="updateItem">
                                            <label for="">{copy.code}</label>
                                            <input type="text" id="" class="form-control" value={items[copy.code] ? items[copy.code] : 0} placeholder="Item Order" onChange={(e) => this.handleChange(e, copy.code)} />

                                            {this.state.loadingBtns[copy.id] ?
                                                <LoadingButton class_name={"sm-btn"} />
                                                :
                                                <button class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onSave(e, copy.code, copy.id)}>{this.state.loadingBtns[copy.id] ? "Loading..." : "Update Order"}</button>
                                            }
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default List;
